import Navbar from "../components/navbar";
import Footer from "../components/footer";
import TextSection from "../components/text-section";

import "swiper/css";
import "swiper/css/grid";
import "swiper/css/pagination"
import "swiper/css/effect-coverflow";
import "react-tabs/style/react-tabs.css";

import BannerTC from "../../../assets/images/banner-term-condition.png";

export default function PrivacyPolicy() {
    const termData = {
        isFetching: false,
        isSuccess: true,
        data: [
            {
                title: 'Pengumpulan Informasi',
                desc: 'Kami mengumpulkan informasi dari Anda ketika Anda mendaftar pada situs kami, masuk ke akun Anda, melakukan pembelian, ikut dalam kontes, dan/atau ketika Anda keluar. Data yang dikumpulkan mencakup nama Anda, alamat email, nomor telepon, dan/atau kartu kredit. <br /></br>Selain itu, kami menerima dan merekam informasi secara otomatis dari komputer dan peramban Anda, termasuk alamat IP Anda, perlengakapan perangkat keras dan lunak Anda, dan halaman yang Anda minta.',
            },
            {
                title: 'Penggunaan Informasi',
                desc: `Segala informasi yang kami kumpulkan dari Anda dapat digunakan untuk:
                    <ul>
                        <li>Personalisasi pengalaman dan tanggapan Anda sesuai kebutuhan pribadi Anda</li>
                        <li>Menyediakan konten iklan yang disesuaikan</li>
                        <li>Meningkatkan situs web kami</li>
                        <li>Meningkatkan layanan pelanggan dan mendukung kebutuhan Anda</li>
                        <li>Menghubungi Anda lewat email</li>
                        <li>Mengatur kontes, promo, atau survei</li>
                    </ul>
                `,
            },
            {
                title: 'Privasi E-Dagang',
                desc: `
                    Kami adalah pemilik tunggal dari informasi yang dikumpulkan pada situs ini. Informasi pribadi Anda yang dapat diidentifikasi tidak akan dijual, dipertukarkan, ditransfer, atau diberikan kepada perusahaan lain dengan alasan apa pun juga, tanpa mendapatkan izin Anda, selain dari hanya semata-mata untuk memenuhi permohonan dan/ atau transaksi, misalnya untuk pengiriman pesanan.
                `,
            },
            {
                title: 'Pengungkapan Pihak Ketiga',
                desc: 'Kami tidak menjual, memperdagangkan, atau pun memindahkan keluar dari pihak kami informasi pribadi Anda yang dapat diidentifikasi. Kami tidak mengikutkan pihak ketiga tepercaya yang membantu kami dalam mengoperasikan situs web kami atau menyelenggarakan bisnis kami, selama semua pihak setuju untuk menjaga kerahasiaan informasi ini. <br /></br>Kami meyakini akan pentingnya berbagi informasi dalam rangka menyelidiki, mencegah, atau mengambil tindakan menyangkut aktivitas ilegal, dugaan penipuan, keadaan yang melibatkan ancaman terhadap keamanan fisik seseorang, pelanggaran atas syarat-syarat penggunaan kami, atau hal lain yang diwajibkan oleh hukum.<br /></br>Namun, informasi bukan privat dapat diberikan kepada pihak lain untuk pemasaran, pariwara, atau penggunaan lain.',
            },
            {
                title: 'Proteksi Informasi',
                desc: 'Kami menerapkan berbagai langkah keamanan guna menjaga keamanan informasi pribadi Anda. Kami menggunakan enripsi teknologi mutakhir untuk memproteksi informasi sensitif yang dikirimkan secara online. Kami mengaryakan mereka yang perlu mengerjakan pekerjaan khusus (contohnya, penagihan atau layanan pelanggan) diberikan akses ke informasi pribadi yang dapat diidentifikasi. Komputer/server yang digunakan untuk menyimpan informasi pribadi yang dapat diidentifikasi disimpan dalam lingkungan yang aman.<br /></br><p className="h-desc" style="color: #191919">Apakah kami menggunakan kuki?</p>Ya. Kuki kami meningkatkan akses ke situs kami dan mengenali pengunjung yang kembali lagi. Lagi pula, kuki kami memperkaya pengalaman pengguna dengan melacak dan menarget minat mereka. Namun, penggunaan kuki ini, tidak mungkin dapat dikaitkan dengan informasi pribadi yang dapat diidentifikasi pada situs kami.',
            },
            {
                title: ' Berhenti Berlangganan',
                desc: 'Kami menggunakan alamat email yang Anda berikan untuk mengirimi Anda informasi dan pembaruan menyangkut pesanan Anda, berita berkala perusahaan, informasi mengenai produk, dll. Bila kapan saja Anda ingin berhenti menerima email kami di masa mendatang, kami memasukkan informasi mendetail informasi berhenti berlangganan di bawah tiap-tiap email.',
            },
            {
                title: 'Persetujuan',
                desc: 'Dengan menggunakan situs kami, Anda setuju dengan kebijakan privasi kami.',
            },
        ]
    };

    return (
        <div className="wrapper-pages">
            <Navbar />

            <div className="about-us">
                <div className="hero">
                    <img src={BannerTC} alt="" />
                    <div className="wrapper">
                        <div className="title-hero">
                            <h1>Privacy <span>Policy</span></h1>
                        </div>
                    </div>
                </div>

                <div className="isi-term">
                    <div className="wrapper">
                        <div className="container">
                            <div className="wrapp-text">
                                {termData.data.map((item, index) => (
                                    <TextSection
                                        key={index}
                                        title={`${index + 1}. ${item.title}`}
                                        desc={item.desc}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="afiliator">
                    <div className="content">
                        <div className="join-reseller join-afiliator">
                            <div className="container">
                                <div className="join-reseller-inner">
                                    <div className="right">
                                        <div className="text">
                                            <h4>Ayoo!!</h4>
                                            <h1 className="h1-xl">Bergabung Affiliate MamaBear</h1>
                                            <p className="p-md">
                                                Hubungi Whatsapp di bawah ini Untuk Mendaftar Menjadi
                                                Reseller MamaBear!
                                            </p>
                                        </div>

                                        <button
                                            onClick={() =>
                                                window.open("https://wa.me/628888695757", "_blank")
                                            }
                                        >
                                            Daftar Sekarang
                                            <svg
                                                width="25"
                                                height="24"
                                                viewBox="0 0 25 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M6.91438 16.5315C6.65562 16.8549 6.70806 17.3269 7.03151 17.5856C7.35495 17.8444 7.82692 17.7919 8.08568 17.4685L12.0857 12.4685C12.3048 12.1946 12.3048 11.8054 12.0857 11.5315L8.08568 6.53145C7.82692 6.208 7.35495 6.15556 7.03151 6.41432C6.70806 6.67308 6.65562 7.14505 6.91438 7.46849L10.5396 12L6.91438 16.5315ZM12.9144 16.5315C12.6556 16.8549 12.7081 17.3269 13.0315 17.5856C13.355 17.8444 13.8269 17.7919 14.0857 17.4685L18.0857 12.4685C18.3048 12.1946 18.3048 11.8054 18.0857 11.5315L14.0857 6.53145C13.8269 6.208 13.355 6.15556 13.0315 6.41432C12.7081 6.67308 12.6556 7.14505 12.9144 7.46849L16.5396 12L12.9144 16.5315Z"
                                                    fill="#DE8D8D"
                                                />
                                            </svg>
                                        </button>
                                    </div>
                                    <div className="left in-afiliator">
                                        <img src="images/afiliator-4-2.jpg" alt="" />
                                        <img
                                            className="desktop"
                                            src="images/afiliator-4-2.jpg"
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}